export const KeyIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="8"
        fill="none"
        viewBox="0 0 15 8"
    >
        <path
            fill="#239DCE"
            d="M3.667 5.08q-.448 0-.762-.315a1.04 1.04 0 0 1-.315-.762q0-.448.315-.763.314-.314.762-.314.447 0 .762.314.315.315.314.763 0 .447-.314.762-.315.315-.762.314m0 2.59q-1.526 0-2.596-1.071Q0 5.527 0 4.003q0-1.526 1.07-2.597T3.668.336q1.071 0 1.938.553a3.7 3.7 0 0 1 1.323 1.447h6.002l1.666 1.667-2.564 2.55-1.237-.929-1.27.943-1.3-.898H6.927a3.7 3.7 0 0 1-1.323 1.444 3.5 3.5 0 0 1-1.938.556m0-1q.959 0 1.66-.58.702-.58.917-1.42h2.295l.96.663 1.302-.952 1.132.865 1.244-1.243-.667-.667H6.244a2.66 2.66 0 0 0-.917-1.42q-.701-.58-1.66-.58-1.1 0-1.884.783A2.57 2.57 0 0 0 1 4.003q0 1.099.783 1.883.784.783 1.884.783"
        ></path>
    </svg>
);